(function () {
  const GRID_SELECTOR = 'ul.product-grid[data-ranking-sort="true"]';
  const ITEM_SELECTOR = ':scope > li.grid__item';
  const CARD_SELECTOR = '.analytics-product-card';
  const PLAN_PRIORITY = {
    enterprise: 4,
    business: 3,
    starter: 2,
    free: 1,
  };

  let sortFrame = null;

  function toNumber(value) {
    const parsed = Number.parseFloat(value || '0');
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function toPlanPriority(value) {
    const normalized = String(value || '')
      .trim()
      .toLowerCase();

    return PLAN_PRIORITY[normalized] || 0;
  }

  function isFallbackProduct(item) {
    return (
      item.rankScore === 0 &&
      item.rating === 0 &&
      item.reviewCount === 0 &&
      item.clicks30d === 0
    );
  }

  function compareItems(left, right) {
    const leftFallback = isFallbackProduct(left);
    const rightFallback = isFallbackProduct(right);

    if (leftFallback && rightFallback) {
      return right.planPriority - left.planPriority || left.index - right.index;
    }

    if (leftFallback !== rightFallback) {
      return leftFallback ? 1 : -1;
    }

    return (
      right.rankScore - left.rankScore ||
      right.rating - left.rating ||
      right.reviewCount - left.reviewCount ||
      right.clicks30d - left.clicks30d ||
      left.index - right.index
    );
  }

  function sortGrid(grid) {
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll(ITEM_SELECTOR));

    if (items.length < 2) return;

    const sortableItems = [];
    const unsortableItems = [];

    items.forEach((item, index) => {
      const card = item.querySelector(CARD_SELECTOR);

      if (!card) {
        unsortableItems.push({ item, index });
        return;
      }

      sortableItems.push({
        item,
        index,
        rankScore: toNumber(card.dataset.rankScore),
        rating: toNumber(card.dataset.rating),
        reviewCount: toNumber(card.dataset.reviewCount),
        clicks30d: toNumber(card.dataset.clicks30d),
        planPriority: toPlanPriority(card.dataset.plan),
      });
    });

    if (sortableItems.length < 2) {
      grid.classList.add('is-ranking-sorted');
      return;
    }

    const sortedItems = sortableItems.slice().sort(compareItems);
    const desiredOrder = sortedItems
      .map((entry) => entry.item)
      .concat(unsortableItems.map((entry) => entry.item));
    const orderChanged = desiredOrder.some((item, index) => item !== items[index]);

    if (!orderChanged) {
      grid.classList.add('is-ranking-sorted');
      return;
    }

    const fragment = document.createDocumentFragment();

    desiredOrder.forEach((item) => {
      fragment.appendChild(item);
    });

    grid.appendChild(fragment);
    grid.classList.add('is-ranking-sorted');
  }

  function sortAllGrids() {
    document.querySelectorAll(GRID_SELECTOR).forEach(sortGrid);
  }

  function scheduleSort() {
    if (sortFrame) {
      window.cancelAnimationFrame(sortFrame);
    }

    sortFrame = window.requestAnimationFrame(() => {
      sortAllGrids();
      sortFrame = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSort, { once: true });
  } else {
    scheduleSort();
  }

  document.addEventListener('shopify:section:load', scheduleSort);
  document.addEventListener('shopify:section:reorder', scheduleSort);

  const observer = new MutationObserver((mutations) => {
    const shouldSort = mutations.some((mutation) => mutation.addedNodes.length > 0);

    if (shouldSort) {
      scheduleSort();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
